<div class="wrapper">
  <section id="area-breadcrumb" class="area-top">
    <div class="container">
      <nav class="breadcrumb">
        <ul>
          <li><a href="/"><strong>Home</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li><a routerLink="/hoteis"><strong>Hotéis</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li>{{detalheHotel?.nome}}, {{detalheHotel?.uf}}</li>
        </ul>
      </nav>
    </div>
  </section>
  <section id="detalhes-hotel">
    <div class="container is-fluid">
      <div class="columns">
        <div class="column is-3" id="montreal-hotel-busca">
          <div class="bg-hoteis" *ngIf="!isMobile">
            <p-autoComplete class="filtro-busca" [(ngModel)]="brand" field="data.nome" [suggestions]="filteredBrands"
                            (completeMethod)="filterBrands($event)" (onSelect)="selectInAutoComplete()" [size]="30" [minLength]="1"
                            placeholder="Refazer a busca">
              <ng-template let-brand pTemplate="item" class="w-100 h-auto-complete">
                <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                  <div style="width:auto;display:inline-block;margin:5px 0 2px 5px">
                    <p>{{getNomeAutoComplete(brand)}} <br>
                      <small>{{getDetalheAutoComplete(brand)}}</small></p>
                  </div>
                  <div style="font-size:13px;float:right;margin: 17px 10px 0 0">
                    {{getQuantidadeHoteis(brand)}} </div>
                </div>
              </ng-template>
            </p-autoComplete>
            <div class="icon-map"><i class="far fa-map-marker"></i></div>
            <div class="hoteis-proximos">
              <h3>Hotéis próximos</h3>
              <p><strong>{{detalheHotel?.nome}}, {{detalheHotel?.uf}}</strong></p>

              <div class="opcoes-proximas" *ngFor="let item of detalheHotel?.hoteisProximos">
                <figure class="area-thumb">
                  <img class="thumb" [src]="item?.foto" alt="foto-hotel"/>
                </figure>
                <div class="area-text">
                  <h5>{{item?.nome}}</h5>
                  <a (click)="navegarParaDetalheHotel(item)" class="ver-detalhes">Ver
                    detalhes</a>
                </div>
              </div>
              <a class="todos-hoteis" (click)="hoteisDestinos(detalheHotel?.codCidade)">Todos os hotéis desta cidade</a>

            </div>
          </div>

          <div *ngIf="!isMobile" class="conheca">
            <h4>Conheça</h4>

            <div class="itens-destinos">
              <div class="tile is-ancestor">
                <div class="tile is-parent photo-destino">
                  <article class="tile is-child notification is-success"
                           [style.backgroundImage]="'url('+ primeiroDestino?.imagem +')'" style="background-size: cover;">
                    <a (click)="irParaDestino(primeiroDestino?.slug)">
                      <div class="img-overlay"></div>
                      <div class="footer">
                        <h3 class="title">{{primeiroDestino?.titulo}}</h3>
                        <p class="subtitle"><i class="fas fa-map-marker"></i> {{primeiroDestino?.estado}}</p>
                        {{primeiroDestino?.resumo}}
                      </div>
                    </a>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-9 resultado-hoteis">
          <div class="columns">
            <div class="column is-8 no-padding-bottom title-hotel">
              <span class="plano">A partir do Plano {{detalheHotel?.tipoPlano}}</span>
              <h1 class="local">{{detalheHotel?.nome}}</h1>
            </div>
            <div class="column is-4 ordenar-busca" *ngIf="!isMobile">
              <div class="menu-right">
                <ul class="nav-page">
                  <li><a (click)="scroll('target_sobre')">Sobre {{detalheHotel?.nome}}, {{detalheHotel?.uf}}</a></li>
                  <li><a (click)="scroll('target_informacao')">Informações</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div id="galeria-hotel">
            <p-galleria
                    [images]="images"
                    panelHeight="{{panelHeight}}"
                    [autoPlay]="false"
                    [showCaption]="true"
                    panelWidth="{{panelWidth}}">
            </p-galleria>

            <div class="columns">
              <div class="column endereco-hotel">
                <a class="link-verde" (click)="getUrlMap(detalheHotel);isOpenMap = true" *ngIf="hasMap(detalheHotel)">
                  <i class="fas fa-map"></i>
                  ver no mapa
                </a>

                <div *ngIf="detalheHotel?.internacional === false || detalheHotel?.internacional === undefined">
                  <p><strong>Endereço:</strong> {{detalheHotel?.endereco}}, {{detalheHotel?.numero}},
                    {{detalheHotel?.cep}}
                    <br> {{detalheHotel?.bairro}} - {{detalheHotel?.cidade}}, {{detalheHotel?.uf}}</p>
                </div>
                <div *ngIf="detalheHotel?.internacional === true">
                  <p>
                    <strong>Endereço:</strong> {{detalheHotel?.endereco}}, {{detalheHotel?.numero}},
                    <br> {{detalheHotel?.bairro}} - {{detalheHotel?.cidade}} - {{detalheHotel?.pais}}
                  </p>
                </div>
              </div>

              <div class="area-button-clube">
                <div id="cadastrar-no-clube" class="column text-right">
                  <div class="area-economize" *ngIf="detalheHotel">
<!--                    <p *ngIf="detalheHotel?.tipoPlano === 'Sem Plano'">-->
<!--                      <span class="line-through">{{detalheHotel?.valoresDiariaMontreal[1].Duplo}}</span>-->
<!--                    </p>-->
<!--                    <p *ngIf="detalheHotel?.tipoPlano !== 'Sem Plano'">Assinaturas <br> a partir de: <br>-->
<!--                      <span class="line-through">{{detalheHotel?.valoresDiariaMontreal.length > 0 ? detalheHotel?.valoresDiariaMontreal[0].Duplo : '0,00'}}</span>-->
<!--                    </p>-->
                    <a (click)="onFacaParte()">
                      <h5>CADASTRAR <br>NO CLUBE</h5>
                    </a>
                  </div>
                </div>
              </div>

            </div>

          </div>

          <div id="sobre-hotel">
            <h3 id="target_sobre">Sobre o Hotel</h3>
            <p>
              {{detalheHotel?.descricao}}
            </p>
          </div>

<!--          <div id="regime-alimentacao" *ngIf="detalheHotel?.regimeAlimentacao && detalheHotel?.regimeAlimentacao.length > 0">-->
<!--            <h3 id="target_regime_alimentacao">Regime de Alimentação</h3>-->
<!--            <div *ngFor="let regimeAlimentacao of detalheHotel?.regimeAlimentacao">-->
<!--              <p>-->
<!--                >> {{regimeAlimentacao}}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div id="comodidades" *ngIf="grupoComodidades && grupoComodidades.length > 0">-->
<!--            <h3 id="target_comodidades">Comodidades</h3>-->
<!--            <div *ngFor="let grupoComodidade of grupoComodidades">-->
<!--              <p>-->
<!--                <a *ngIf="showComodidades(grupoComodidade)" (click)="clickHideComodidade(grupoComodidade)"><i class="fas fa-chevron-down"></i></a>-->
<!--                <a *ngIf="!showComodidades(grupoComodidade)" (click)="clickShowComodidade(grupoComodidade)"><i class="fas fa-chevron-right"></i></a>-->
<!--                {{grupoComodidade.nome}}-->
<!--              </p>-->
<!--              <div *ngIf="showComodidades(grupoComodidade)">-->
<!--                <p style="padding-left: 1em" *ngFor="let comodidade of grupoComodidade.comodidades">-->
<!--                  <i [class]="comodidade.icon"></i>-->
<!--                  {{comodidade.nome}}-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->

<!--          <div id="informacoes">-->
<!--            <h3 id="target_informacao">Informações</h3>-->

<!--            <div id="quartos">-->
<!--              <p><strong>Quartos</strong></p>-->
<!--              <p>-->
<!--            <span *ngFor="let item of detalheHotel?.tipoQuarto">-->
<!--              <span *ngIf="item === 'Simples'">-->
<!--                <i class="fas fa-user"></i>-->
<!--                <br>-->
<!--                Simples-->
<!--              </span>-->
<!--              <span *ngIf="item === 'Duplo'">-->
<!--                <i class="fas fa-user"></i>-->
<!--                <i class="fas fa-user"></i>-->
<!--                <br>-->
<!--                Duplo-->
<!--              </span>-->
<!--              <span *ngIf="item === 'Triplo'">-->
<!--                <i class="fas fa-user"></i>-->
<!--                <i class="fas fa-user"></i>-->
<!--                <i class="fas fa-user"></i>-->
<!--                <br>-->
<!--                Triplo-->
<!--              </span>-->
<!--            </span>-->
<!--              </p>-->
<!--            </div>-->

<!--            <div id="informativo">-->
<!--              <p *ngFor="let item of detalheHotel?.informativo"><i class="fas fa-chevron-right"></i>&nbsp; {{item}}</p>-->
<!--            </div>-->

<!--&lt;!&ndash;            <div id="periodos" *ngIf="isPlanosPeriodo(detalheHotel)">&ndash;&gt;-->
<!--&lt;!&ndash;              <h3>Tabela de Planos por Período</h3>&ndash;&gt;-->
<!--&lt;!&ndash;              <p>&ndash;&gt;-->
<!--&lt;!&ndash;                Na tabela abaixo é possível verificar em qual plano o&ndash;&gt;-->
<!--&lt;!&ndash;                {{detalheHotel?.nome}}&ndash;&gt;-->
<!--&lt;!&ndash;                <br>&ndash;&gt;-->
<!--&lt;!&ndash;                se encaixa, de acordo com o período que deseja viajar.&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->
<!--&lt;!&ndash;              <div *ngIf="isPlanoPeriodo(detalheHotel?.planosPeriodoDuplo)" id="planos-periodo-duplo">&ndash;&gt;-->
<!--&lt;!&ndash;                <p>Quarto duplo:</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <div *ngIf="isContratoPeriodo(detalheHotel?.planosPeriodoDuplo, 'D')">&ndash;&gt;-->
<!--&lt;!&ndash;                  <p *ngFor="let duplo of detalheHotel?.planosPeriodoDuplo">&ndash;&gt;-->
<!--&lt;!&ndash;                    De {{duplo.inicioPeriodo | date: 'dd/MM/yyyy'}} até {{duplo.finalPeriodo | date: 'dd/MM/yyyy'}} = {{obterNomePlano(duplo.planoDuplo, "Duplo")}}&ndash;&gt;-->
<!--&lt;!&ndash;                  </p>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div *ngIf="isPlanoPeriodo(detalheHotel?.planosPeriodoTriplo)" id="planos-periodo-triplo">&ndash;&gt;-->
<!--&lt;!&ndash;                <p >Quarto triplo:</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <div *ngIf="isContratoPeriodo(detalheHotel?.planosPeriodoTriplo, 'T')">&ndash;&gt;-->
<!--&lt;!&ndash;                  <p *ngFor="let triplo of detalheHotel?.planosPeriodoTriplo">&ndash;&gt;-->
<!--&lt;!&ndash;                    De {{triplo.inicioPeriodo | date: 'dd/MM/yyyy'}} até {{triplo.finalPeriodo | date: 'dd/MM/yyyy'}} = {{obterNomePlano(triplo.planoTriplo, "Triplo")}}&ndash;&gt;-->
<!--&lt;!&ndash;                  </p>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div *ngIf="!isContratoPeriodo(detalheHotel?.planosPeriodoTriplo, 'T')">&ndash;&gt;-->
<!--&lt;!&ndash;                  <p *ngFor="let triplo of detalheHotel?.planosPeriodoTriplo">&ndash;&gt;-->
<!--&lt;!&ndash;                    {{triplo.planoTriplo}}&ndash;&gt;-->
<!--&lt;!&ndash;                  </p>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;              </div>&ndash;&gt;-->

<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--            <div id="endereco">-->
<!--              <p class="endereco"><strong><i class="fas fa-map-marker"></i>Endereço</strong></p>-->
<!--              <div *ngIf="detalheHotel?.internacional === false || detalheHotel?.internacional === undefined">-->
<!--                <p>-->
<!--                  {{detalheHotel?.endereco}}-->
<!--                  <br>{{detalheHotel?.bairro}} - {{detalheHotel?.cidade}} ({{detalheHotel?.uf}})-->
<!--                  <br>CEP: {{detalheHotel?.cep}}-->
<!--                </p>-->
<!--              </div>-->
<!--              <div *ngIf="detalheHotel?.internacional === true">-->
<!--                {{detalheHotel?.endereco}}-->
<!--                <br>{{detalheHotel?.bairro}} - {{detalheHotel?.cidade}} {{detalheHotel?.pais}}-->
<!--              </div>-->

<!--            </div>-->

<!--          </div>-->

        </div>
      </div>
    </div>
  </section>
  <app-tabela-diarias-facilita></app-tabela-diarias-facilita>
    <app-new-footer></app-new-footer>
</div>

<div *ngIf="detalheHotel && isOpenMap" class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <button class="delete" (click)="isOpenMap = false" aria-label="close"></button>
    </header>
    <section class="modal-card-body" style="height: 400px;overflow: hidden;">
      <iframe [src]="sanitizer.bypassSecurityTrustResourceUrl(urlMap)" width="100%" height="100%">
        <p>Your browser does not support iframes.</p>
      </iframe>
    </section>
  </div>
</div>
